import {
  ArrowRightLeft,
  Boxes,
  Building2,
  Cloud,
  Settings2,
  Workflow,
} from 'lucide-react';

const highlights = [
  {
    title: 'Modernize Your Core ERP Systems',
    description:
      'PT KCS helps companies modernize core ERP systems by identifying process improvements and guiding the move to connected platforms. We align technology with business goals and prepare systems to scale.',
    Icon: ArrowRightLeft,
  },
  {
    title: 'ERP Solutions for Growing SMEs',
    description:
      'PT KCS helps growing SMEs choose lightweight ERP and accounting SaaS suited to their workflows and budgets. Our guidance helps streamline daily operations and support growth.',
    Icon: Building2,
  },
  {
    title: 'Infor Consulting',
    description:
      'PT KCS helps organizations get more from Infor through solution planning, implementation, integration, optimization, and ongoing support.',
    Icon: Boxes,
  },
  {
    title: 'SAP Consulting',
    description:
      'PT KCS helps businesses shape SAP around their operational needs, from system assessment and implementation planning to integration and modernization.',
    Icon: Workflow,
  },
  {
    title: 'Odoo Consulting',
    description:
      'PT KCS helps businesses use Odoo to connect key workflows, configure applications to fit their processes, and support implementation and adoption.',
    Icon: Settings2,
  },
  {
    title: 'ERP Modernization and Cloud Adoption',
    description:
      'PT KCS helps organizations move from legacy systems to cloud ERP and accounting SaaS by evaluating options and planning a smooth migration.',
    Icon: Cloud,
  },
];

export default function ERPConsultingHighlights() {
  return (
    <section className="px-6 py-12 sm:px-8 sm:py-16 lg:px-[9.25vw]" style={{ backgroundColor: '#ffffff' }}>
      <h2
        className="mb-12 text-center sm:mb-14 text-[32px] font-semibold leading-[48px]"
        style={{ color: '#183762' }}
      >
        Why Choose PT KCS for ERP and CRM Consulting?
      </h2>
      <div className="grid w-full grid-cols-1 gap-6 sm:grid-cols-2 lg:grid-cols-3 lg:gap-8">
        {highlights.map(({ title, description, Icon }) => (
          <article
            key={title}
            className="flex h-full flex-col items-start rounded-xl p-6 shadow-[0_8px_28px_rgba(35,61,104,0.12)] transition duration-300 hover:-translate-y-1 hover:shadow-[0_16px_36px_rgba(35,61,104,0.18)] sm:p-7"
            style={{ backgroundColor: '#ffffff' }}
          >
            <div
              className="mb-5 grid h-[68px] w-[68px] place-items-center rounded-full"
              style={{ backgroundColor: '#e1ebff', color: '#233d68' }}
              aria-hidden="true"
            >
              <Icon size={30} strokeWidth={1.7} />
            </div>
            <h2 className="mb-3 text-xl font-semibold leading-snug" style={{ color: '#183762' }}>
              {title}
            </h2>
            <p className="text-base font-normal leading-[27px]" style={{ color: '#212121' }}>
              {description}
            </p>
          </article>
        ))}
      </div>
    </section>
  );
}
